<template>
    <v-app class="larapress-app">
        <v-main :id="id" :style="contentStyles">
            <v-carousel v-if="options.slides"
            :class="options.slideClass"
            :style="options.slideStyle"
            v-bind="options.slideProperties"
            >
                <v-carousel-item v-for="(slide, i) in options.slides" :key="`carousel-header-${i}`" >
                    <v-img v-bind="slide" />
                </v-carousel-item>
            </v-carousel>
            <v-container :class="`${options && options.contClass ? options.contClass : 'fill-height'}`" fluid>
                <v-row align="center" justify="center" :class="`${options && options.rowClass ? options.rowClass :''}`">
                    <v-col class="pa-0" cols="12" v-bind="options" :class="`${options && options.colClass ? options.colClass :''}`">
                        <vuetify-formjson v-bind="this[this.getFormSchemaPropName()]" v-model="formModel"></vuetify-formjson>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import FormJSONRenderer from '../Lib/vuetify-formjson/Fields/FormJSONBuilder/generator'
import {
    UserAwareComponent
} from '../Lib/custom-components/mixins'

export default {
    mixins: [FormJSONRenderer, UserAwareComponent],
    name: 'page-template-centered',
    props: {
        id: String,
        options: {
            type: Object,
            default: () => ({
                md: 6,
                sm: 12
            })
        },
        sources: {
            type: Array,
            default: () => ([])
        },
        body: {
            type: Object,
            default: () => ({
                schema: {},
                code: "",
                values: {}
            })
        },
    },
    data: (vm) => ({
        contentStyles: {
            background: vm.options.background ?? ''
        }
    }),
    mounted() {
        if (this.body) {
            this.UpdatePageContent(this.body, this.options, this.sources)
        }
    },
    watch: {
        body() {
            this.UpdatePageContent(this.body, this.options, this.sources)
        }
    }
}
</script>
